/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Endpoint_Seller_Schema_LinkInputs */

const en_endpoint_seller_schema_link = /** @type {((inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Selling this API? See the full schema your endpoint must return.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Selling this API? " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "See the full schema your endpoint must return" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const zh_hans1_endpoint_seller_schema_link = /** @type {((inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`你在出售这个 API？查看你的接口必须返回的完整数据结构。`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "你在出售这个 API？" }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "查看你的接口必须返回的完整数据结构" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "。" }])
			})
		}
	)
);

const pt_br2_endpoint_seller_schema_link = /** @type {((inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Vende esta API? Veja o schema completo que o seu endpoint precisa retornar.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Vende esta API? " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Veja o schema completo que o seu endpoint precisa retornar" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const es_endpoint_seller_schema_link = /** @type {((inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`¿Vendes esta API? Consulta el esquema completo que debe devolver tu endpoint.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "¿Vendes esta API? " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Consulta el esquema completo que debe devolver tu endpoint" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const fr_endpoint_seller_schema_link = /** @type {((inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Vous vendez cette API ? Consultez le schéma complet que votre endpoint doit renvoyer.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Vous vendez cette API ? " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Consultez le schéma complet que votre endpoint doit renvoyer" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const de_endpoint_seller_schema_link = /** @type {((inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Du verkaufst diese API? Hier ist das vollständige Schema, das dein Endpoint zurückgeben muss.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Du verkaufst diese API? " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Hier ist das vollständige Schema, das dein Endpoint zurückgeben muss" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const ru_endpoint_seller_schema_link = /** @type {((inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Продаёте этот API? Полная схема, которую должен возвращать ваш эндпоинт.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Продаёте этот API? " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Полная схема, которую должен возвращать ваш эндпоинт" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

const it_endpoint_seller_schema_link = /** @type {((inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString) & { parts: (inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Vendi questa API? Consulta lo schema completo che il tuo endpoint deve restituire.`)
		}),
		{
			parts: /** @type {(inputs: Endpoint_Seller_Schema_LinkInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "text", value: "Vendi questa API? " }, { type: "markup-start", name: "link", options: {}, attributes: {} }, { type: "text", value: "Consulta lo schema completo che il tuo endpoint deve restituire" }, { type: "markup-end", name: "link", options: {}, attributes: {} }, { type: "text", value: "." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Selling this API? See the full schema your endpoint must return." |
*
* @param {Endpoint_Seller_Schema_LinkInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const endpoint_seller_schema_link = /** @type {((inputs?: Endpoint_Seller_Schema_LinkInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & { parts: (inputs?: Endpoint_Seller_Schema_LinkInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Endpoint_Seller_Schema_LinkInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, { link: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Endpoint_Seller_Schema_LinkInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			if (locale === "zh-Hans") return zh_hans1_endpoint_seller_schema_link(inputs)
			if (locale === "pt-BR") return pt_br2_endpoint_seller_schema_link(inputs)
			if (locale === "es") return es_endpoint_seller_schema_link(inputs)
			if (locale === "fr") return fr_endpoint_seller_schema_link(inputs)
			if (locale === "de") return de_endpoint_seller_schema_link(inputs)
			if (locale === "ru") return ru_endpoint_seller_schema_link(inputs)
			if (locale === "it") return it_endpoint_seller_schema_link(inputs)
			return en_endpoint_seller_schema_link(inputs)
		}),
		{
			parts: /** @type {(inputs?: Endpoint_Seller_Schema_LinkInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				if (locale === "zh-Hans") return typeof zh_hans1_endpoint_seller_schema_link.parts === "function" ? zh_hans1_endpoint_seller_schema_link.parts(inputs) : [{ type: "text", value: zh_hans1_endpoint_seller_schema_link(inputs) }]
				if (locale === "pt-BR") return typeof pt_br2_endpoint_seller_schema_link.parts === "function" ? pt_br2_endpoint_seller_schema_link.parts(inputs) : [{ type: "text", value: pt_br2_endpoint_seller_schema_link(inputs) }]
				if (locale === "es") return typeof es_endpoint_seller_schema_link.parts === "function" ? es_endpoint_seller_schema_link.parts(inputs) : [{ type: "text", value: es_endpoint_seller_schema_link(inputs) }]
				if (locale === "fr") return typeof fr_endpoint_seller_schema_link.parts === "function" ? fr_endpoint_seller_schema_link.parts(inputs) : [{ type: "text", value: fr_endpoint_seller_schema_link(inputs) }]
				if (locale === "de") return typeof de_endpoint_seller_schema_link.parts === "function" ? de_endpoint_seller_schema_link.parts(inputs) : [{ type: "text", value: de_endpoint_seller_schema_link(inputs) }]
				if (locale === "ru") return typeof ru_endpoint_seller_schema_link.parts === "function" ? ru_endpoint_seller_schema_link.parts(inputs) : [{ type: "text", value: ru_endpoint_seller_schema_link(inputs) }]
				if (locale === "it") return typeof it_endpoint_seller_schema_link.parts === "function" ? it_endpoint_seller_schema_link.parts(inputs) : [{ type: "text", value: it_endpoint_seller_schema_link(inputs) }]
				return typeof en_endpoint_seller_schema_link.parts === "function" ? en_endpoint_seller_schema_link.parts(inputs) : [{ type: "text", value: en_endpoint_seller_schema_link(inputs) }]
			})
		}
	)
);